export enum UserTypes {
    Organisation = 'organisation',
    Group = 'group',
    Provider = 'provider',
    Tenant = 'tenant',
    Clinical = 'clinical',
    Patient = 'patient',
    Unlimited = 'unlimited'
}
